import { logEvent } from "firebase/analytics";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { analytics } from "./firebase";

const AnalyticsTracker = () => {
    const location = useLocation();

    useEffect(() => {
        const screenName = location.pathname;

        logEvent(analytics, 'screen_view_web', {
            firebase_screen: screenName,
            firebase_screen_class: screenName,
        });

        console.log('Screen_View', screenName);
    }, [location.pathname]);

    return null;
};

export default AnalyticsTracker;